export const TURN_OS_VACANCIES_URL = 'https://turn-os.upandup.co/vacant-homes'

export const turnOsProjectUrl = (id: string) =>
  `https://turn-os.upandup.co/projects/${encodeURIComponent(id)}`
